// extracted by mini-css-extract-plugin
module.exports = {"box":"box--VNQIk","mainMod":"mainMod--AgpTu","item":"item--5NKG3"};